export const DocumentStateIds = [1, 2, 3, 4, 5, 6, 7];

export default class DocumentState {
    static ALL = -1; // no incluir en DocumentStateIds
    static VALIDATED = 1;
    static PENDING_VALIDATION = 2;
    static PENDING = 3;
    static EXPIRED = 4;
    static REFUSED = 5;
    static ARCHIVED = 6;
    static NO_APPLY = 7;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/DocumentState.js